import { InputTypes, ValueTypes } from 'app/interfaces';


export default {
	key: 'trip_service_rule_id',
	name: 'Criterio',
	inputType: InputTypes.DATASET_AUTOCOMPLETE,
	valueType: ValueTypes.REFERENCE,
	datasetCode: 'trip_service_rules',
	inputHint: 'Scrivi per cercare un criterio',
	remoteOptions: {
		limit: 100,
		getLabel(option): any{
			if(!option) return '';
			return '(' + option.code + ') ' + option.description;
		},
		getValue(option): any{
			if(!option) return;
			return option.id;
		},
		getDisplay(option): any{
			if(!option) return '';
			return '(' + option.code + ') ' + option.description;
		}
	}
};
